import { z } from "zod";

export const ForgotPasswordValidationSchema = z.object({
 codigo: z
        .string()
        .min(4, { message: "Código é obrigatório!" }),
    });
